import BasicMarketingClientSelectionEnum = Meevo.Model.BasicMarketingClientSelectionEnum;
import BasicMarketingDateRangeSelectionEnum = Meevo.Model.BasicMarketingDateRangeSelectionEnum;

module Meevo.Plugins.BasicEmailMarketing {

    export enum AmountItemTypeEnum {
        ServicesAndProducts,
        Services,
        Products,
    }

    export interface IDateRange {
        eventId: BasicMarketingClientSelectionEnum;
        dateRangeEnum: BasicMarketingDateRangeSelectionEnum;
        isDefault: boolean;
        order: number;
        validationJson?: string;
    }

    export interface IAmountModel {
        min: number;
        max: number;
        amountItemType: AmountItemTypeEnum;
        services: string[];
        serviceCategories: string[];
        products: string[];
        productCategories: string[];
        employees: string[];
        employeeCategories: string[];
    }

    export class EmmaGroup {
        member_group_id: number;
        group_name: string;
        active_count: number;
        optout_count: number;
        error_count: number;
        is_locked: boolean;
        selected: boolean;
    }
}
